import API  from '@/api';

const fetchCreateBulk = payload => {
  const headers = {
    Accept: 'application/json',
    Authorization: `Bearer ${sessionStorage.getItem('token')}`
  };

  const formData = new FormData();
  Object.keys(payload).map(key => {
    if (!Array.isArray(payload[key])) {
      formData.append(key, payload[key]);
      return;
    }
    payload[key].map(item => formData.append(`${key}[]`, item));
  });

  return fetch(`${API}/panel/code/bulk/`, {
    method: 'POST',
    headers,
    body: formData,
  });
};

export default fetchCreateBulk;
